import React from "react";
import styles from "./styles.module.css";
import { Flex } from "components/containers/Flex";
import { TextSubtitle2 } from "fonts/Subtitle2";
import { Spacing } from "spacing/component";
import { with2XS } from "spacing/reducers/vertical";
import { LogoOnWhite } from "components/assets/LogoOnWhite";

import menu from "../../assets/icons/40.svg";

export type SidebarOption =
  | "Home"
  | "Organizations"
  | "Users"
  | "Courses"
  | "Settings";

interface Props {
  activeOption?: SidebarOption;
  options: SidebarOption[];
  onChange: (option: SidebarOption) => void;
  onLogoClick?: () => void;
  expanded: boolean;
  setExpanded: (isExpanded: boolean) => void;
}

export const Sidebar = ({
  options,
  activeOption,
  onChange,
  onLogoClick,
  expanded,
  setExpanded
}: Props) => (
  <div className={classNames(styles, { expanded })}>
    <Spacing pv="s" ph={expanded ? "s" : "3xs"}>
      <Flex justifyContentEnd>
        <button onClick={() => setExpanded(!expanded)}>
          <img src={menu} />
        </button>
      </Flex>
    </Spacing>
    <Spacing pb={expanded ? "m" : "8xl"} ph={expanded ? "s" : undefined}>
      <FullWidth>
        <LogoOnWhite className={styles.logo} onClick={onLogoClick} />
      </FullWidth>
    </Spacing>
    <Flex column>
      {options
        .map(option => ({
          option,
          active: option === activeOption,
          onClick: () => onChange(option),
          expanded
        }))
        .map(SidebarOptionComponent)
        .reduce(with2XS)}
    </Flex>
  </div>
);

interface SidebarOptionModel extends SVGModel {
  option: SidebarOption;
  active?: boolean;
  expanded: boolean;
  onClick: () => void;
}

const SidebarOptionComponent = ({
  option,
  active,
  onClick,
  expanded
}: SidebarOptionModel) => (
  <button {...{ onClick }}>
    <Spacing ph={expanded ? "s" : "3xs"} pv="s">
      <Flex alignItemsCenter>
        <SVG {...{ option, active }} />
        {expanded && (
          <React.Fragment>
            <Spacing pl="xs" />
            <TextSubtitle2 paletteBlue1={active}>{option}</TextSubtitle2>
          </React.Fragment>
        )}
      </Flex>
    </Spacing>
  </button>
);

interface SVGModel {
  option: SidebarOption;
  active?: boolean;
}

import home from "../../assets/icons/1.svg";
import homeActive from "../../assets/icons/1a.svg";

import organizations from "../../assets/icons/32.svg";
import organizationsActive from "../../assets/icons/32a.svg";

import users from "../../assets/icons/7.svg";
import usersActive from "../../assets/icons/7a.svg";

import courses from "../../assets/icons/42.svg";
import coursesActive from "../../assets/icons/42a.svg";

import settings from "../../assets/icons/9.svg";
import settingsActive from "../../assets/icons/9a.svg";
import { FullWidth } from "components/containers/FullWidth";
import { classNames } from "helpers/string";

const SVG = ({ option, active }: SVGModel) => {
  switch (option) {
    case "Home":
      return <img src={active ? homeActive : home} />;
    case "Organizations":
      return <img src={active ? organizationsActive : organizations} />;
    case "Users":
      return <img src={active ? usersActive : users} />;
    case "Courses":
      return <img src={active ? coursesActive : courses} />;
    case "Settings":
      return <img src={active ? settingsActive : settings} />;
  }
};
